import { Input } from 'fukku/Input'
import type { ReactNode, RefCallback } from 'react'
import { cx } from 'utils/cx'

import styles from './Textarea.module.scss'

export interface TextareaProps {
	readonly id: string
	readonly className?: string
	readonly label?: string
	readonly labelFocused?: string
	readonly errorPlaceholders?: Record<string, string | number>
	readonly errorMessage?: string
	readonly hintPlaceholders?: Record<string, string | number>
	readonly hintMessage?: string
	readonly disabled?: boolean
	readonly placeholder?: string
	readonly name?: string
	readonly forceHint?: boolean
	readonly value?: string
	readonly onBlur?: () => void
	readonly onChange?: (value: string) => void
	readonly onFocus?: () => void
	readonly onInput?: () => void
	readonly children?: ReactNode
	readonly refCallback?: RefCallback<HTMLTextAreaElement & HTMLInputElement>
}

export const Textarea = (props: TextareaProps): React.ReactNode => {
	return (
		<Input
			{...props}
			showAsTextArea
			className={cx(styles.box, props.className)}
		/>
	)
}
